import { render, staticRenderFns } from "./AccountUserUsage.vue?vue&type=template&id=4839f4a4&scoped=true"
import script from "./AccountUserUsage.vue?vue&type=script&lang=js"
export * from "./AccountUserUsage.vue?vue&type=script&lang=js"
import style0 from "./AccountUserUsage.vue?vue&type=style&index=0&id=4839f4a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4839f4a4",
  null
  
)

export default component.exports